import moment from "moment";
import "moment/locale/id";

const rupiah = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR",
  maximumFractionDigits: 0,
});

export function getAmount(value) {
  if (typeof value !== "number" && typeof value !== "string") return null;
  if (typeof value === "string" && !value.trim()) return null;
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
}

export function formatRupiah(value) {
  const amount = getAmount(value);
  return amount === null ? "-" : rupiah.format(amount);
}

export function formatDate(value) {
  return value && moment(value).isValid()
    ? moment(value).locale("id").format("DD MMMM YYYY")
    : "-";
}

export function sumAmounts(rows, selectValue) {
  const amounts = rows.map((row) => getAmount(selectValue(row))).filter((value) => value !== null);
  return {
    total: amounts.length ? amounts.reduce((sum, value) => sum + value, 0) : null,
    available: amounts.length,
  };
}
